import React from 'react';

import { Form } from 'react-form';

import {
  Fieldset,
  Legend,
  StackedFormSection,
  TextAreaField
} from 'v1/components/shared';
import { DatePicker } from 'v5/design-system/DatePicker';

import { maybe } from '@passionware/monads';
import { dateConvert } from 'v5/platform/lang/dateConvert';

// TODO: Date inputs are one step behind

const RequestAvailabilityDetailsForm = ({ request, onChange }) => {
  return (
    <div className="RequestAvailabilityModal">
      <Form
        defaultValues={request}
        onChange={formApi => onChange(formApi.values)}
        validateOnSubmit
      >
        {formApi => (
          <form onSubmit={formApi.submitForm}>
            <Fieldset>
              <Legend className="form-legend">
                <h3>Enter Details</h3>
              </Legend>
              <StackedFormSection
                title="Requested dates"
                description="Resources will be guided to fill in availability between these dates"
              >
                <div className="tailwind-root contents">
                  <DatePicker
                    className="w-full"
                    mode="range"
                    allowChangeGranularity={false}
                    // popoverExtra={<DatePickerPresets />}
                    value={{
                      from: dateConvert.dateOnly.parse.toLocalDate(
                        formApi.values.startTimestampUTC
                      ),
                      to: dateConvert.dateOnly.parse.toLocalDate(
                        formApi.values.endTimestampUTC
                      )
                    }}
                    onChange={({ from, to }) => {
                      formApi.setValue(
                        'startTimestampUTC',
                        maybe.map(
                          from,
                          dateConvert.dateOnly.format.fromLocalDate
                        )
                      );
                      formApi.setValue(
                        'endTimestampUTC',
                        maybe.map(to, dateConvert.dateOnly.format.fromLocalDate)
                      );
                    }}
                    placeholder="Select date range"
                  />
                </div>
              </StackedFormSection>
              <StackedFormSection
                title="Add message"
                description="Write a message that will be attached within the email"
              >
                <TextAreaField field="message" placeholder="Start writing..." />
              </StackedFormSection>
            </Fieldset>
          </form>
        )}
      </Form>
    </div>
  );
};

export default RequestAvailabilityDetailsForm;
